import React from "react";
import PropTypes from "prop-types";
import {
  classStringBuilder,
  conditionallyAddStyles,
  isValueSteelColor,
  isSpecial,
} from "../../support/helpers";
import EditingOptionAsset from "./editing-option-asset";
import { useSelector } from "react-redux";
import { selectOptionFromKey } from "../../customisation-slice";

const propTypes = {
  optionValue: PropTypes.instanceOf(Object).isRequired,
  optionKey: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  selectedOption: PropTypes.string,
  editingKey: PropTypes.string.isRequired,
};

const defaultProps = {
  className: "",
};

const EditingOption = ({
  optionValue,
  optionKey,
  className,
  onClick,
  selectedOption,
  editingKey,
}) => {
  const caseState = useSelector((state) => selectOptionFromKey(state, "case"));

  const defaultClasses = [
    "border-r",
    "md:even:border-r-0",
    "md:border-b",
    "min-w-1/2-screen",
    "md:min-w-0",
    "max-w-200",
    "md:max-w-none",
    "h-110",
    "hover:bg-very-light-grey",
    "disabled:cursor-not-allowed",
  ];

  const additionalClasses = className.split(" ");

  conditionallyAddStyles(
    optionKey === selectedOption,
    additionalClasses,
    "bg-beige"
  );

  conditionallyAddStyles(
    isSpecial(optionValue.type),
    additionalClasses,
    "md:h-210",
    "md:h-175"
  );

  const classes = classStringBuilder(defaultClasses, additionalClasses);

  const isDisabled = () => {
    if (
      editingKey === "strap" &&
      isValueSteelColor(optionKey) &&
      caseState.selected !== optionKey
    ) {
      return true;
    }
    return false;
  };

  const getHoverTitleText = () =>
    isDisabled()
      ? "This option is not compatible with your case selection"
      : "";

  return (
    <button
      className={classes}
      onClick={onClick}
      disabled={isDisabled()}
      title={getHoverTitleText()}
    >
      <div
        className={`flex flex-col items-center justifiy-center ${
          isDisabled() ? "opacity-20" : ""
        } `}
      >
        <EditingOptionAsset optionValue={optionValue} />
        <div className="heading-7 mt-3 md:mt-6">{optionValue.title}</div>
      </div>
    </button>
  );
};

EditingOption.propTypes = propTypes;

EditingOption.defaultProps = defaultProps;

export default EditingOption;
